import React from 'react';
import BlogFacebookIcon from '../../../../assets/img/blog-fb-bottom.inline.svg';
import BlogTwitterIcon from '../../../../assets/img/blog-X-bottom.inline.svg';
import BlogLinkedInIcon from '../../../../assets/img/blog-linkedin-bottom.inline.svg';
import BlogWhatsappIcon from '../../../../assets/img/blog-whatsapp-bottom.inline.svg';

import { formatPathString } from "../../../../util/util"

const SocialShareIcon = ({ blogSubtitle, blogTitle }) => {

    const handleShare = (url, shareType) => {
        const customText = `${blogSubtitle} From @joinkuda`;

        switch (shareType) {
            case "FB":
                return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(customText)}`;

            case "X":
                return `https://twitter.com/intent/tweet?text=${encodeURIComponent(customText)}&url=${encodeURIComponent(url)}`;

            case "In":
                const link = `${customText} ${url}`;
                return `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}&text=${encodeURIComponent(link)}`;

            case "Whatsapp":
                return `https://api.whatsapp.com/send?text=${encodeURIComponent(customText)}%20${encodeURIComponent(url)}`

            default:
                break;
        }
    }
    const formatedPath = formatPathString(blogTitle);

    return (
        <div className='socail-share-icons'>
            <a href={handleShare(`${process.env.GATSBY_ENV_URL}/blog/${formatedPath}/`, 'FB')} target="_blank" rel="noopener noreferrer">
                <BlogFacebookIcon className='blog-social-icon' />
            </a>
            <a href={handleShare(`${process.env.GATSBY_ENV_URL}/blog/${formatedPath}/`, 'X')} target="_blank" rel="noopener noreferrer">
                <BlogTwitterIcon className='blog-social-icon' />
            </a>
            <a href={handleShare(`${process.env.GATSBY_ENV_URL}/blog/${formatedPath}/`, 'In')} target="_blank" rel="noopener noreferrer">
                <BlogLinkedInIcon className='blog-social-icon' />
            </a>
            <a href={handleShare(`${process.env.GATSBY_ENV_URL}/blog/${formatedPath}/`, 'Whatsapp')} target="_blank" rel="noopener noreferrer">
                <BlogWhatsappIcon className='blog-social-icon' />
            </a>
        </div>
    )
};

export default SocialShareIcon;